<template>
  <div class="home flex-row">
    <div class="container-left flex-col">
      <div
        class="about-debris"
        v-if="debrisLanguageType == 1"
        @click="goAboutDebris"
      >
        <span>关于DEBRIS</span>
      </div>
      <div
        class="about-debris en-language"
        v-if="debrisLanguageType == 2"
        @click="goAboutDebris"
      >
        <span>About DEBRIS</span>
      </div>
      <div
        class="showreel"
        v-if="debrisLanguageType == 1"
        @click="goShowreel"
      >
        <span>作品混剪</span>
      </div>
      <div
        class="showreel en-language"
        v-if="debrisLanguageType == 2"
        @click="goShowreel"
      >
        <span>Showreel</span>
      </div>
    </div>
    <div class="container-right flex-col">
      <div v-if="debrisLanguageType == 1" class="about-us" @click="goAboutUs">
        <span>关于我们</span>
      </div>
      <div v-if="debrisLanguageType == 2" class="about-us en-language" @click="goAboutUs">
        <span>About Us</span>
      </div>
      <div class="others flex-row">
        <div class="works-show" v-if="debrisLanguageType == 1" @click="goWorks">
          <span>作品展示</span>
        </div>
        <div class="works-show en-language" v-if="debrisLanguageType == 2" @click="goWorks">
          <span>Works</span>
        </div>
        <div class="contact-us flex-col justify-between">
          <span v-if="debrisLanguageType == 1">联系我们</span>
          <span class="en-txt" v-if="debrisLanguageType == 2">Contact</span>
          <span class="mail">debrisanimationstudio@gmail.com</span>
          <span v-if="debrisLanguageType == 1" class="copy-btn" :style="!copySuccess ? 'text-decoration: underline;' : ''" @click="copy">
            {{ copySuccess ? "复制成功！" : "复制地址" }}
          </span>
          <span v-if="debrisLanguageType == 2" class="copy-btn en-txt" :style="!copySuccess ? 'text-decoration: underline;' : ''" @click="copy">
            {{ copySuccess ? "Copy Successful!" : "Copy" }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      mail: "debrisanimationstudio@gmail.com",
      copySuccess: false,
      copyTimer: null,
    };
  },
  created() {},
  computed: {
    debrisLanguageType() {
      return this.$store.state.debrisLanguageType;
    },
  },
  methods: {
    goAboutDebris() {
      this.$router.push({ name: "AboutDebris" });
    },
    goAboutUs() {
      this.$router.push({ name: "AboutUs" });
    },
    goWorks() {
      this.$router.push({ name: "Works" });
    },
    goShowreel() {
      if (this.debrisLanguageType == 1) {
        window.open('https://www.bilibili.com/video/BV11QQcYmEf2/?spm_id_from=333.337.search-card.all.click', '_blank');
      } else {
        window.open('https://youtu.be/YmXtLdKZQms', '_blank');
      }
    },
    copy() {
      // 清除之前的定时器
      if (this.copyTimer) {
        clearTimeout(this.copyTimer);
      }
      // 创建input元素
      const el = document.createElement("input");
      // 给input元素赋值需要复制的文本
      el.setAttribute("value", this.mail);
      // 将input元素插入页面
      document.body.appendChild(el);
      // 选中input元素的文本
      el.select();
      // 复制内容到剪贴板
      document.execCommand("copy");
      // 删除input元素
      document.body.removeChild(el);
      // 设置复制成功状态
      this.copySuccess = true;
      // 2秒后恢复原样
      this.copyTimer = setTimeout(() => {
        this.copySuccess = false;
      }, 2000);
    },
  },
  beforeDestroy() {
    // 组件销毁时清除定时器
    if (this.copyTimer) {
      clearTimeout(this.copyTimer);
    }
  },
};
</script>

<style lang="scss">
.home {
  width: 100%;
  height: 8.16rem;
  background: url("../assets/image/others/home_bg.jpg");
  // background-size: 100% 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 9;
  .en-language{
    span{
      font-family: "Poppins Bold" !important;
    }
  }
  .container-left {
    width: 50%;
    height: 100%;

    .about-debris,
    .showreel {
      width: 100%;
      height: 50%;
      transition: all 0.2s;
      cursor: pointer;
      padding: 0.24rem 0 0 0.24rem;
      background: rgba(38, 38, 38, 0.5);
      span {
        color: #ffffff;
        font-family: "Alibaba-PuHuiTi-Bold";
        font-size: 0.4rem;
        display: none;
        text-shadow: 0px 1px 6px rgba(46, 46, 46, 0.6);
      }
      &:hover {
        background: rgba(38, 38, 38, 0);
        span {
          display: block;
        }
      }
    }
  }

  .container-right {
    width: 50%;
    height: 100%;

    .about-us {
      width: 100%;
      height: 50%;
      background: rgba(38, 38, 38, 0.5);
      transition: all 0.2s;
      padding: 0.24rem 0 0 0.24rem;
      cursor: pointer;
      span {
        color: #ffffff;
        font-family: "Alibaba-PuHuiTi-Bold";
        font-size: 0.4rem;
        display: none;
        text-shadow: 0px 1px 6px rgba(46, 46, 46, 0.6);
      }
      &:hover {
        background: rgba(38, 38, 38, 0);
        span {
          display: block;
        }
      }
    }

    .others {
      width: 100%;
      height: 50%;

      .works-show {
        width: 5.76rem;
        height: 100%;
        background: rgba(38, 38, 38, 0.5);
        transition: all 0.2s;
        padding: 0.24rem 0 0 0.24rem;
        cursor: pointer;
        span {
          color: #ffffff;
          font-family: "Alibaba-PuHuiTi-Bold";
          font-size: 0.4rem;
          display: none;
          text-shadow: 0px 1px 6px rgba(46, 46, 46, 0.6);
        }
        &:hover {
          background: rgba(38, 38, 38, 0);
          span {
            display: block;
          }
        }
      }

      .contact-us {
        width: calc(100% - 5.76rem);
        height: 100%;
        background: rgba(38, 38, 38, 0.5);
        transition: all 0.2s;
        padding: 0.24rem 0.24rem 0.35rem;
        span {
          color: #ffffff;
          font-family: "Alibaba-PuHuiTi-Bold";
          font-size: 0.4rem;
          display: none;
          text-shadow: 0px 1px 6px rgba(46, 46, 46, 0.6);
        }
        &:hover {
          background: rgba(38, 38, 38, 0);
          span {
            display: block;
          }
        }
        .mail {
          font-size: 0.36rem;
          word-break: break-all;
          display: none;
          font-family: "Poppins";
        }
        .copy-btn {
          cursor: pointer;
          display: none;
          font-family: "Alibaba-PuHuiTi-Regular";
          font-size: 0.2rem;
        }
        .en-txt{
          font-family: "Poppins Bold" !important;
        }
      }
    }
  }
}
</style>
